import React, {useMemo} from 'react';
import {classes, style} from './doppe-page-social-links.st.css';
import {DoppeDtoSocialLink, doppeDtoSocialLinkResolveUrl} from '../../client-server-common/types/doppe-dto-social-link';
import {IconButton} from '@wix/devzai-utils-react';
import {iterableMapToArray, ObservableValue} from '@wix/devzai-utils-common';
import {doppeViewerSocialLinkResolveIcon} from '../doppe-viewer-social-links/doppe-viewer-social-links';
import {bymoPageSocialLinkIsHidden, getSocialLinkActionId} from '../../client-server-common';
import {doppeDtoActionExtendWithDefaultProps, DoppeDtoActionViewType} from '../../client-server-common/types/doppe-dto-action';
import {DoppeViewerActionRenderer} from '../doppe-viewer-action-renderer/doppe-viewer-action-renderer';
import {
    doppeActionTypeSocialIcon
} from '../../doppe-action-types/doppe-action-type-social-icon/doppe-action-type-social-icon';
import {BymoPageViewerMode, useBymoPageViewerContext} from '../bymo-page-viewer-context/bymo-page-viewer-context';
import {useDoppeViewerClientServices} from '../../client/doppe-user-app/doppe-viewer-client-services';
import {
    DoppeActionGoalType,
    WidgetRenderingContextType
} from '../../client-server-common/doppe-action-types/doppe-action-type';

export const DoppePageSocialLinks = React.memo(function DoppePageSocialLinks(props: DoppePageSocialLinks.Props) {
        const {
            socialLinks,

            className,
            ...htmlAttributes
        } = props;


        const clientServices = useDoppeViewerClientServices();
        const pageViewerContext = useBymoPageViewerContext();
        const observableIsRenderingInnerState = useMemo(()=>{
            return new ObservableValue(false);
        }, []);

        return (
            <div
                {...htmlAttributes}
                className={style(classes.root, className)}
            >
                {iterableMapToArray(socialLinks, (socialLink, skip, index) => {

                    if (bymoPageSocialLinkIsHidden(socialLink)) {
                        return skip;
                    }

                    const url = doppeDtoSocialLinkResolveUrl(socialLink);

                    if (!url) {
                        return skip;
                    }

                    return (
                        <DoppeViewerActionRenderer
                            key={index}
                            action={doppeDtoActionExtendWithDefaultProps({
                                viewType: DoppeDtoActionViewType.InPage,
                                settings: {},
                                actionTypeId: doppeActionTypeSocialIcon.id,
                                callToActionDescription: '',
                                enabled: true,
                                id: getSocialLinkActionId(socialLink.platform),
                                name: ''
                            })}
                            actionIndex={index}
                            observableCurrentItemIdToRender={undefined}
                            observableIsRenderingInnerState={observableIsRenderingInnerState}
                            widgetRenderingContextType={WidgetRenderingContextType.Strip}
                        >
                            {(actionContext) => {
                                return (
                                    <IconButton
                                        tagName={'a'}
                                        href={url}
                                        target={'_blank'}
                                        className={style(classes.socialLinkButton, {})}
                                        icon={doppeViewerSocialLinkResolveIcon(socialLink)}
                                        onClick={() => {
                                            actionContext.reportGoalAchieved({
                                                goalType: DoppeActionGoalType.SocialIconClick
                                            });
                                            if (pageViewerContext.mode === BymoPageViewerMode.Live) {
                                                clientServices.viewerAnalyticsClient.logEvent('uouSocialIconClicked', {
                                                    hypeUserId: pageViewerContext.doppeUserId,
                                                    pageId: pageViewerContext.bymoPageId,
                                                    iconUrl: url,
                                                    iconType: socialLink.platform,
                                                    linkId: '',
                                                })
                                            }
                                        }}
                                    />
                                )
                            }}
                        </DoppeViewerActionRenderer>
                    )
                })}
            </div>
        );
    })
;

export namespace DoppePageSocialLinks {

    export interface Props extends React.HTMLAttributes<any> {
        socialLinks: DoppeDtoSocialLink[];
    }
}
